import { useState } from 'react';
import styled from 'styled-components';
import { animated, useSpring, useTransition, config } from 'react-spring';

import data from './data/emotions.json';
import { useMedia } from './hooks';
import { Emotions } from './components/Emotions';
import { Content } from './components/Content';

const Wrapper = styled.div`
  height: 100vh;
  width: 100vw;
  background: white;
  display: flex;
  
  @media screen and (min-width: 768px) {
    padding: 16px;
  }
`;

const AnimatedContainer = styled(animated.div)`
  background: #F8F2FF;
  margin: auto;
  position: relative;
`;

const ScollContainer = styled.div`
  overflow-y: auto;
  height: 100%;
`;

const EmotionScollContainer = styled(ScollContainer)`
  overflow-y: auto;
  @media screen and (min-width: 360px) {
    overflow-y: unset;
  }
`;

const widths = [
  ['100%', '100%', '75%', '70%'],
  ['100%', '100%', '80%', '75%']
];

const heights = [
  ['100%', '55%', '55%', '50%'],
  ['100%', '100%', '100%', '100%']
];

const App = () => {
  const size = useMedia(['(min-width: 1400px)', '(min-width: 1200px)', '(min-width: 768px)'], [3, 2, 1], 0);

  const [showContent, setShowContent] = useState(false);
  const [index, setIndex] = useState(0);

  const spring = useSpring({
    minWidth: widths[showContent ? 1 : 0][size],
    minHeight: heights[showContent ? 1 : 0][size],
    borderRadius: showContent ? 8 : 16,
    config: config.subtle
  });


  const transitions = useTransition(!showContent, null, {
    from: { position: 'absolute', width: '100%', height: '100%' },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: config.subtle
  });

  const handleSelect = i => {
    setIndex(i);
    setShowContent(true);
  };

  const handleBack = () => setShowContent(false);

  return (
    <Wrapper>
      <AnimatedContainer style={spring}>
        {transitions.map(({ item, key, props }) => {
          return item ? (
            <animated.div key={key} style={props}>
              <EmotionScollContainer>
                <Emotions data={data} handleSelect={handleSelect} />
              </EmotionScollContainer>
            </animated.div>
          ) : (
              <animated.div key={key} style={props}>
                <ScollContainer>
                  <Content data={data[index]} handleBack={handleBack} />
                </ScollContainer>
              </animated.div>
            )
        })}
      </AnimatedContainer>
    </Wrapper>
  );
};

export default App;
